import {OPEN_CONTACT} from '../constants'; 


export const openContact = (payload) => {
    return{
        type: OPEN_CONTACT,
        payload: payload,
    }
}